import type { FormikContextType } from 'formik';
import { useFormik } from 'formik';
import { useRef } from 'react';
import * as Yup from 'yup';
import { Alert } from '../../../../store';
import type { ScheduledEvent} from '../../graphql';
import {  useUpdateEventAdminFields } from '../../graphql';

export interface Props {
  scheduledEvent: ScheduledEvent;
}

interface Values {
  banner: string;
  redirectURL: string;
}

interface Form {
  formik: FormikContextType<Values>;
  loading: boolean;
  error?: Error | undefined;
  alert: Alert;
  event: unknown;
}

export const useForm = ({ scheduledEvent: event }: Props): Form => {
  // const [mutation, { loading, error, event: event_ }] = useEdit();

  const [updateEvent, { loading, error, event: event_  }] = useUpdateEventAdminFields();

  const alert = Alert.useAlert(error);

  const initialValues = useRef({
    banner: event.banner ?? '',
    redirectURL: event.redirect_url ?? ''
  }).current;

  const validationSchema = Yup.object({
    // redirectURL: Yup.string().trim().url('Please provide a valid url')
  });

  const formik = useFormik<Values>({
    initialValues,
    validationSchema,
    validateOnMount: true,
    validateOnBlur: true,

    async onSubmit(values: Values) {

      // If not loading, execute the mutation
      if (!loading) {
        await updateEvent({
          ...values,
          id: Number(event.id)
        });
      }
    }
  });

  return {
    formik,
    loading,
    error,
    alert,
    event: event_
  };
};
